
<script>
import Layout from '@/router/layouts/main';
import InventoryInfo from './main.vue';

/**
 * Dashboard Component
 */
export default {
  page: {
    title: 'Item',
  },
  components: {
    Layout,
    InventoryInfo,
  },
  data() {
    return {
      items: [
        {
          text: '',
          href: '/inventory/manage',
        },
        {
          text: '',
          active: true,
        },
      ],
    };
  },
};
</script>

<template>
  <Layout :title="$t('general.manage')">
    <InventoryInfo :itemIdPublic="this.$route.params.idPublic" />
  </Layout>
</template>